
import Cookies from 'js-cookie'

export function phoneConfig(field_name) {
  const bindProps = {
    mode: 'international',
    disabledFetchingCountry: false,
    placeholder: field_name,
    required: true,
    validCharactersOnly: true,
    name: "contact_number",
    maxLen: 20
  }

  return bindProps;
}

export function getUserAppUuid() {
  return Cookies.get('user-appuuid')
}

export function getAppUuid() {
  return Cookies.get('appuuid')
}


export function getErrorMessage(error, vue) {
  const err_msg = (error.message || error.toString());
  const serror = err_msg.replace(/[\s\/]/g, "");
  return vue.$t(serror) !==
    serror ? vue.$t(serror) : err_msg;
}

export async function sleep(seconds = 1) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('AWAKE');
    }, seconds*1000)
  });
}

/**
 * 
 * @param {Function} func 
 * @param {number} interval 
 * @returns {Function}
 */
export function debounce(func, interval = 1000) {
  let _timeout;
  return function(...args){
    const that = this;
    clearTimeout(_timeout)
    _timeout = setTimeout(function() {
      func.apply(that, args);
    }, interval);
  }
}